import { navigateToPage, setLocalStorageItem } from '@marketplace-web/shared/browser'
import { SINGLE_CHECKOUT_URL } from 'constants/routes'

import { SINGLE_CHECKOUT_LOAD_TIME_TRACKING_DETAILS_STORAGE_KEY } from '../constants'

export const markSingleCheckoutLoadStartTime = (orderId: number) => {
  const loadTimeStartStamp = new Date().getTime()
  const trackingDetails = {
    orderId,
    loadTimeStartStamp,
  }

  setLocalStorageItem(
    SINGLE_CHECKOUT_LOAD_TIME_TRACKING_DETAILS_STORAGE_KEY,
    JSON.stringify(trackingDetails),
  )
}

export const navigateToSingleCheckout = (
  checkoutId: string,
  orderId: number,
  orderType: string,
) => {
  markSingleCheckoutLoadStartTime(orderId)
  navigateToPage(SINGLE_CHECKOUT_URL(checkoutId, orderId, orderType))
}
